import styled from "styled-components";
import {
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
} from "@website-builder/utilities-index";

export const RatingWrapper = styled.div`
	padding: 60px 0 10px;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	overflow: hidden;
	width: 100%;
`;

export const Container = styled.div`
	margin: 0 62px 50px;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		margin: 0 20px 50px;
	}
`;

export const Reviews = styled.div`
	font-size: 22px;
	font-weight: ${FONT_WT_MEDIUM};
	margin-top: 18px;
	a {
		display: flex;
		justify-content: center;
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
	.ratings {
		font-size: 16px;
		margin: 6px 0 0 2px;
	}
`;
